import { Box, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { mergeSxProps } from "@src/appV2/lib";
import { type ReactNode } from "react";

export interface MobilePageWrapperProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Lightweight page wrapper for mobile pages.
 * Does NOT set height or overflow - MobileApp handles the scroll container and safe areas.
 * Just provides consistent horizontal spacing.
 */
export function MobilePageWrapper(props: MobilePageWrapperProps) {
  const { children, sx } = props;

  return (
    <Box
      sx={mergeSxProps(
        {
          display: "flex",
          flexDirection: "column",
          paddingX: 5,
        },
        sx
      )}
    >
      {children}
    </Box>
  );
}
